import { createAsyncThunk } from "@reduxjs/toolkit";

import { type TraineeWithAssignedTrainer } from "@fitness-app/data-models/entities/Trainee";

import { type AsyncThunkCreator } from "../../../index";
import { getUserClaims } from "../../user/selectors";
import { TRAINEES_REDUCER_NAME } from "../types";
import { buildTraineesWithoutPlanQuery } from "./buildTraineesWithoutPlanQuery";

type Payload = void;

export const fetchTraineesWithoutPlan = createAsyncThunk<
  {
    list: TraineeWithAssignedTrainer[];
    count: number;
  },
  Payload,
  AsyncThunkCreator<string>
>(
  `${TRAINEES_REDUCER_NAME}/fetchTraineesWithoutPlan`,
  async (_payload, { rejectWithValue, extra: { db }, getState }) => {
    const { memberId, isAdministration } = getUserClaims(getState());

    if (!memberId) {
      throw new Error("user-is-not-logged");
    }

    const query = buildTraineesWithoutPlanQuery(
      db,
      isAdministration ? { type: "tenant" } : { type: "assignedTrainer", assignedTrainerId: memberId },
    );

    const { error, data, count } = await query.returns<TraineeWithAssignedTrainer[]>();

    if (error) {
      return rejectWithValue(error.message);
    }

    return {
      list: data,
      count: count ?? data.length,
    };
  },
);
